module.exports = __webpack_public_path__ + "img/content-us-img.bd321400.png";